/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuProviderModule} from '@irian-ro/menu-provider-module';
import {NotificationUiPanelComponent} from './components/notification-ui-panel/notification-ui-panel.component';
import {NotificationDataService} from './services/notification-data.service';
import {DisplayNotificationUiPanelService} from './services/display-notification-ui-panel.service';
import {NotificationEndpoint} from './services/notification.endpoint';
import {NotificationUiButtonComponent} from './components/notification-ui-button/notification-ui-button.component';
import {StompModule} from '@irian-ro/stomp-module';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NavigationModule} from '@irian-ro/navigation-module';
import {EnvironmentModule, SharedComponentsModule} from '@irian-ro/shared-components-module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import * as langs from "../i18n/i18n";
import {ButtonModule} from "primeng/button";
import {TooltipModule} from "primeng/tooltip";

@NgModule({
    imports: [
        CommonModule,
        MenuProviderModule,
        BrowserAnimationsModule,
        ButtonModule,
        TooltipModule,
        StompModule,
        SharedComponentsModule,
        TranslateModule,
        NavigationModule.forChild([{ key: 'test2', link: 'resource-availability/timeline' }], null, null),
        EnvironmentModule
    ],
    declarations: [
        NotificationUiPanelComponent,
        NotificationUiButtonComponent
    ],
    exports: [
        NotificationUiButtonComponent
    ],
    providers: []
})
export class NotificationUiModule {
  constructor(private translateService: TranslateService) {
    Object.keys(langs).map(lang => {
      translateService.setTranslation(lang, langs[lang], true);
    });
  }

  static forRoot(): ModuleWithProviders<NotificationUiModule> {
    return {
      ngModule: NotificationUiModule,
      providers: [
        DisplayNotificationUiPanelService,
        NotificationDataService,
        NotificationEndpoint
      ]
    };
  }
}

